import { useState } from 'preact/hooks'

interface ConfirmationState {
  isOpen: boolean
  title: string
  message: string
  type?: 'danger' | 'warning' | 'info'
  confirmText?: string
  cancelText?: string
  onConfirm?: () => void | Promise<void>
  loading?: boolean
}

export function useConfirmation() {
  const [confirmationState, setConfirmationState] = useState<ConfirmationState>({
    isOpen: false,
    title: '',
    message: '',
    type: 'danger',
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    loading: false
  })

  const showConfirmation = (options: Omit<ConfirmationState, 'isOpen' | 'loading'>) => {
    setConfirmationState({
      ...options,
      isOpen: true,
      loading: false
    })
  }

  const hideConfirmation = () => {
    setConfirmationState(prev => ({ ...prev, isOpen: false, loading: false }))
  }

  const handleConfirm = async () => {
    if (confirmationState.onConfirm) {
      setConfirmationState(prev => ({ ...prev, loading: true }))
      try {
        await confirmationState.onConfirm()
        hideConfirmation()
      } catch (error) {
        // Keep modal open if there's an error
        setConfirmationState(prev => ({ ...prev, loading: false }))
        throw error
      }
    } else {
      hideConfirmation()
    }
  }

  return {
    confirmationState,
    showConfirmation,
    hideConfirmation,
    handleConfirm
  }
}
